import { render, staticRenderFns } from "./ScrollTopComp.vue?vue&type=template&id=7b3ab951&scoped=true&"
import script from "./ScrollTopComp.vue?vue&type=script&lang=js&"
export * from "./ScrollTopComp.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTopComp.vue?vue&type=style&index=0&id=7b3ab951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3ab951",
  null
  
)

export default component.exports